import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MoveVertical = createReactComponent("MoveVertical", ["svg", defaultAttributes, [["polyline", {
  points: "8 18 12 22 16 18",
  key: "1s5whx"
}], ["polyline", {
  points: "8 6 12 2 16 6",
  key: "rp6fz1"
}], ["line", {
  x1: "12",
  y1: "2",
  x2: "12",
  y2: "22",
  key: "1hqhh2"
}]]]);
export default MoveVertical;